import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from "@angular/core";
import { MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { TranslateModule } from "@ngx-translate/core";
import { MatToolbar } from "@angular/material/toolbar";
import { MatIcon } from "@angular/material/icon";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators
} from "@angular/forms";
import { MatButton, MatButtonModule } from "@angular/material/button";
import { Store } from "@viewer/core";
import { MatStepperModule } from "@angular/material/stepper";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { StepperSelectionEvent } from "@angular/cdk/stepper";
import { DdnData } from "@orion2/models/tocitem.models";

@Component({
  standalone: true,
  imports: [
    MatIcon,
    FormsModule,
    MatButton,
    MatToolbar,
    TranslateModule,
    MatDialogModule,
    MatStepperModule,
    MatFormFieldModule,
    MatButtonModule,
    MatStepperModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  selector: "o-ddn-modal",
  templateUrl: "./ddn-modal.component.html",
  styleUrl: "./ddn-modal.component.scss"
})
export class DdnModalComponent implements OnInit {
  public currentStepTitle: string;
  public senderForm: FormGroup;
  public receiverForm: FormGroup;
  public remarkForm: FormGroup;

  constructor(
    private readonly formBuilder: FormBuilder,
    private dialog: MatDialogRef<DdnModalComponent>,
    public store: Store
  ) {}

  ngOnInit(): void {
    this.senderForm = this.getContactGroup();
    this.receiverForm = this.getContactGroup();
    this.remarkForm = this.getRemarksGroup();
    this.onStepChange({ selectedIndex: 0 } as StepperSelectionEvent);
  }

  /**
   * Update modal title when step change
   * Set remarkForm values with sender and receiver information
   * @param event to have index of the current step
   */
  public onStepChange(event: StepperSelectionEvent) {
    const stepTitles = ["comments.ddn.sender", "comments.ddn.receiver", "comments.ddn.code"];
    this.currentStepTitle = stepTitles[event.selectedIndex];
    // set remarkForm values (senderIdent and receiverIdent) with sender and receiver cageCode
    if (event.selectedIndex === 2) {
      const senderCageCode = this.senderForm.get("cageCode").value.toUpperCase();
      const receiverCageCode = this.receiverForm.get("cageCode").value.toUpperCase();
      this.remarkForm.get("senderIdent").setValue(senderCageCode);
      this.remarkForm.get("receiverIdent").setValue(receiverCageCode);
    }
  }

  /**
   * Close the modal and return undefined ddnData
   */
  public close(): void {
    this.dialog.close();
  }

  /**
   * Close the modal and return ddnData from step forms
   */
  public submit() {
    if (!this.senderForm.valid || !this.receiverForm.valid || !this.remarkForm.valid) {
      return;
    }
    const date = new Date();
    const { remarks, ...code } = this.remarkForm.getRawValue();
    const { cageCode: _1, ...senderContact } = this.senderForm.getRawValue();
    const { cageCode: _2, ...receiverContact } = this.receiverForm.getRawValue();
    const ddnData: DdnData = {
      code,
      senderContact,
      receiverContact,
      remarks,
      issueDate: {
        year: date.getFullYear().toString(),
        month: (date.getMonth() + 1).toString(),
        day: date.getDate().toString()
      }
    };
    this.dialog.close(ddnData);
  }

  /**
   * return the contact group
   * used in steps "sender information" and "receiver information"
   */
  private getContactGroup(): FormGroup {
    return this.formBuilder.group({
      entrepriseName: this.formBuilder.control("", [Validators.required]),
      cageCode: this.formBuilder.control("", [Validators.required, Validators.pattern(/^\w{5}$/)]),
      email: this.formBuilder.control("", [Validators.email]),
      phone: this.formBuilder.control("", [Validators.pattern(/^\+?\d{0,15}$/)]),
      street: this.formBuilder.control(""),
      postal: this.formBuilder.control(""),
      city: this.formBuilder.control(""),
      state: this.formBuilder.control(""),
      country: this.formBuilder.control("")
    });
  }

  /**
   * return the remark group
   * used in last step "DDN Code"
   */
  private getRemarksGroup(): FormGroup {
    return this.formBuilder.group({
      model: this.formBuilder.control({
        value: this.store.pubInfo.model.toUpperCase(),
        disabled: true
      }),
      senderIdent: this.formBuilder.control({ value: "", disabled: true }),
      receiverIdent: this.formBuilder.control({ value: "", disabled: true }),
      year: this.formBuilder.control({
        value: new Date().getFullYear().toString(),
        disabled: true
      }),
      seqNumber: this.formBuilder.control("00001", [
        Validators.required,
        Validators.pattern(/^\d{5}$/)
      ]),
      remarks: this.formBuilder.control("")
    });
  }
}
